import { createFileRoute, redirect } from '@tanstack/react-router';
import { supportedLngs } from '../utils/ConstCapture';

const detectLanguage = (): string => {
  const browserLang = (navigator.language || '').toLowerCase().split('-')[0];
  if (supportedLngs.includes(browserLang)) {
    return browserLang;
  }
  return 'es';
};

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({
      to: '/$lang/workstations',
      params: { lang: detectLanguage() },
    });
  },
});
